import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './assets/global.css'
import '@mdi/font/css/materialdesignicons.css'  
import store from "./store";
import mixin from "./mixin";
import displayPlugin from './plugins/display'

// Suppress ResizeObserver loop error (common in development with Vuetify)
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/
const resizeObserverLoopErr = /^ResizeObserver loop completed with undelivered notifications/
window.addEventListener('error', (e) => {
  if (resizeObserverLoopErrRe.test(e.message) || resizeObserverLoopErr.test(e.message)) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div')
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay')
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none')
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none')
    }
  }
})

require("@/store/subscriber");
require("./axios.js");

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {

const app = createApp(App)
app.use(router)
app.use(store)
app.use(vuetify)
app.use(displayPlugin)
app.mixin(mixin);
app.mount('#app')

// ✅ Remove loader after mount
window.addEventListener('load', () => {
  const loader = document.getElementById('app-loader')
  if (loader) {
    loader.style.opacity = '0'
    loader.style.transition = 'opacity 0.4s ease'
    setTimeout(() => loader.remove(), 400)
  }
})

});

